<template>
    <div class="workPie">
        <div id="workOrderPie"></div>
        <div class="legendBox">
            <ul>
                <li v-for="(item, index) in pieData" :key="index" >
                    <div>
                        <i :style="{ background: color[index] }"></i>
                        <span class="title">{{ item.name }}</span>
                    </div>
                    <div>
                        <span>{{ item.radito|filter2 }}%</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
    import echarts from 'echarts';
    export default {
        props: {
            pieData: Array,
            linepieCount: Number
            // pieDataList: Array
        },
        data () {
            return {
                pieChart: null,
                color: [
                    '#36B374',
                    '#FF8C19',
                    '#FF4D4D',
                    '#FFD338',
                    '#AC4FE6',
                    '#2283E6',
                    '#f59a8f',
                    '#fdb301',
                    '#57e7ec',
                    '#cf9ef1'
                ],
                totla: 0
            };
        },
        watch: {
            pieData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.initChart();
                            break;
                        }
                    }
                },
                deep: true
            },
            // linepieCount (newVal, oldVal) {
            //     if(newVal != oldVal) {
            //         this.linepieCount = newVal;
            //     }
            // }
        },
        created () {

        },
        mounted () {
            // this.pieDataList = this.pieData.sort(function(a, b){
            //     let obj = ['五级', '二级', '四级', '一级', '三级', '未评级'];
            //     return obj.indexOf(a.name) - obj.indexOf(b.name) 
            // })
            
            this.pieChart = echarts.init(document.getElementById('workOrderPie'));
            this.initChart();
        },
        methods: {
            initChart () {
                this.totla = 0;
                this.pieData.forEach(element => {
                    this.totla += element.value;
                });
                let option = {
                    backgroundColor: 'rgba(255,255,255,1)',
                    color: this.color,
                    title: {
                        show: true,
                        text: '资源等级占比分析',
                        // x: 'center',
                        // subtext: '总数(个)',
                        textStyle: {
                            color: '#333',
                            fontSize: 14
                        },
                        // subtextStyle: {
                        //     show: true,
                        //     fontSize: 12,
                        //     color: 'rgba(51,51,51,1)',
                        //     align: 'center'
                        // },
                        // textAlign: 'center',
                        x: '5%',
                        y: '5%'
                    },
                    series: [
                        {
                            type: 'pie',
                            // clockwise: false, // 饼图的扇区是否是顺时针排布
                            // minAngle: 10, // 最小的扇区角度（0 ~ 360）
                            radius: [0, 53],
                            center: ['40%', '50%'],
                            avoidLabelOverlap: false,
                            hoverAnimation: false, // 控制悬浮动画
                            itemStyle: {
                                // 图形样式 可以控制有没有分割线
                                normal: {
                                    borderColor: '#ffffff',
                                    borderWidth: this.linepieCount > 1 ? 2 : 0
                                }
                            },
                            label: {
                                normal: {
                                    show: false,
                                    position: 'center',
                                    // formatter: '{text|{b}}\n总数{c} ({d}%)',
                                    formatter: '{text|{b}}\n总数{c}',
                                    rich: {
                                        text: {
                                            color: '#666',
                                            fontSize: 14,
                                            align: 'center',
                                            verticalAlign: 'middle',
                                            padding: 8
                                        },
                                        value: {
                                            color: '#8693F3',
                                            fontSize: 24,
                                            align: 'center',
                                            verticalAlign: 'middle'
                                        }
                                    }
                                },
                                emphasis: {
                                    show: false,
                                    textStyle: {
                                        fontSize: 24
                                    }
                                }
                            },
                            data: this.pieData
                        }
                    ]
                };
                this.pieChart.setOption(option);
            }
        },
        beforeDestroy () {
            this.pieChart.dispose();
        },
        destroyed () {
            this.pieChart.dispose();
        },
        filters: {
            filter1 (value) {
                if (!value) {
                    return '0'
                } else {
                    return value
                }
            },
            filter2 (value) {
                if (isNaN(value)) {
                    return '0'
                } else {
                    return value
                }
            }
        }
    };
</script>
<style lang="less" scope>
.workPie {
    height: 206px;
    width: 100%;
    overflow: hidden;
    display: flex;
    #workOrderPie {
        width: 50%;
        height: 99%;
        box-sizing: border-box;
    }
    .legendBox {
        width: 50%;
        line-height: center;
        display: flex;
        justify-content: center;
        ul {
            width: 100%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-wrap: wrap;
            flex-direction: column;
            box-sizing: border-box;
            padding-top: 38px;
            li {
                display: flex;
                flex-direction: column;
                width: 50%;
                align-items: left;
                justify-content: flex-start;
                justify-content: space-between;
                div:nth-child(1) {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    i {
                        display: inline-block;
                        height: 8px;
                        width: 8px;
                        margin-right: 10px;
                    }
                    .title {
                        font-size: 12px;
                        font-weight: 500;
                        color: rgba(51, 51, 51, 1);
                    }
                }

                div:nth-child(2) {
                    margin-top: 8px;
                    padding-left: 18px;
                    width: 100%;
                    margin-bottom: 12px;
                    span:nth-child(1) {
                        font-size: 12px;
                        display: inline-block;
                        font-weight: 400;
                        margin-right: 15px;
                        width: 27px;
                        color: rgba(102, 102, 102, 1);
                        white-space: nowrap;

                    }
                    span:nth-child(2) {
                        font-size: 12px;
                        display: inline-block;
                        font-weight: 400;
                        width: 43px;
                        white-space: nowrap;
                        text-align: left;
                        color: rgba(102, 102, 102, 1);
                    }
                }
            }
        }
    }
}
</style>
